import httpClient from '../httpClient';

const createSectionForm = async (data) => {
  return await httpClient.post(`form_section/`, data);
};

const deleteSectionForm = async (id) => {
  return await httpClient.delete(`form_section/${id}/`);
};

const getSectionForm = async (id) => {
  return await httpClient.get(`form_section/${id}/`);
};

const updateSectionForm = async (id, data) => {
  return await httpClient.put(`form_section/${id}/`, data);
};

const querySections = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/form_section/?page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
    { params: query },
  );
};

export {
  createSectionForm,
  deleteSectionForm,
  querySections,
  getSectionForm,
  updateSectionForm,
}
